module.exports = __webpack_public_path__ + "static/media/expandMapIcon.e097eed6.svg";